<template>
  <div class="container ">
    <van-nav-bar :title="$t('text.txt36')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()"/>
      </template>
      <template #right>
        <span class="nav-right" @click="$router.push({path:'/WithdrawRecord'})">{{ $t("text.txt33") }}</span>
      </template>
    </van-nav-bar>
    <div class="main">
      <div class="withdrawMoney">
        <div style="margin-top: 10px">
          <span>{{ $t('withdraw.money') }}</span>
          <div class="money">
            <div class="moneyNumber">
              <span class="moneyType" style="margin-right: 10px">{{ $store.getters.getBaseInfo.currency }}</span>
              <van-field v-model="withdraw_money" :placeholder="$t('请输入金额')" type="number" />
            </div>
            <span class="all" @click="allMoeny()">{{ $t('withdraw.all') }}</span>
          </div>
        </div>


        <div style="margin-top: 10px">
          <span>{{ $t('类型') }}</span>
          <div style="border-bottom: 1px solid #f2f2f5;padding: 10px 0">
            <div>
                <label><input type="radio" value="1" v-model="type"> {{ $t("银行卡") }}</label>
            </div>
            <div style="margin-top: 15px">
                <label><input type="radio" value="0" v-model="type"> {{ $t("加密货币") }}</label>
            </div>
          </div>
        </div>

        <div style="margin-top: 10px" v-if="type == 1">
          <span>{{ $t('姓氏') }}</span>
          <div class="money">
            <van-field v-model="branch" :placeholder="$t('请输入姓氏')" type="text" />
          </div>
        </div>

        <div style="margin-top: 10px" v-if="type == 1">
          <span>{{ $t('名字') }}</span>
          <div class="money">
            <van-field v-model="branch_number" :placeholder="$t('请输入名字')" type="text" />
          </div>
        </div>

        <div style="margin-top: 10px" v-if="type == 1">
          <span>{{ $t('银行名称') }}</span>
          <div class="money">
            <van-field v-model="bankinfo" :placeholder="$t('请输入银行名称')" type="text" />
          </div>
        </div>
        <div style="margin-top: 10px" v-if="type == 1">
          <span>{{ $t('ACH') }}</span>
          <div class="money">
            <van-field v-model="financial_institution" :placeholder="$t('请输入ACH')" type="text" />
          </div>
        </div>
        <div style="margin-top: 10px" v-if="type == 1">
          <span>{{ $t('账号') }}</span>
          <div class="money">
            <van-field v-model="account_number" :placeholder="$t('请输入账号')" type="text" />
          </div>
        </div>
        <div style="margin-top: 10px" v-if="type == 0">
          <span>{{ $t('币种名称') }}</span>
          <div class="money">
            <van-field v-model="currency_name" :placeholder="$t('请输入币种名称')" type="text" />
          </div>
        </div>
        <div style="margin-top: 10px">
          <span>{{ $t('地址') }}</span>
          <div class="money">
            <van-field v-model="bankid" :placeholder="$t('请输入地址')" type="text" />
          </div>
        </div>

        <div class="information">
          <div class="description">
            <van-popover v-model="showPopover" trigger="click">
              <div class="popover-body" style="padding: 10px;">
                <p>1.{{ $t('withdraw.min') }}{{this.withdrawRole.min}},{{ $t('withdraw.max') }}{{this.withdrawRole.max}}</p>
                <p>2.{{ $t('withdraw.num') }}{{this.withdrawRole.num}}{{ $t('msg.次') }}</p>
                <p>3.{{ $t('withdraw.hint') }}</p></div>
              <template #reference @click="withdrawInfo()">
                <van-icon name="info-o" />
                {{ $t('withdraw.quota') }}
              </template>
            </van-popover>
          </div>

          <div class="balance">
            <span>{{ $t('withdraw.balance') }}：</span>
            <span class="number">{{ this.userInfo.money }}</span>
          </div>
        </div>
      </div>
      <van-button class="withdraw_btn" type="default" @click="doWithdraw()">{{ $t("withdraw.withdraw") }}</van-button>

    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showPopover: false,
      withdraw_money:"",
      userInfo:{},
      withdrawRole:{},
      type: 1,
      branch: "",
      branch_number: "",
      bankinfo: "",
      bankid: "",
      financial_institution: "",
      currency_name: "",
      bank_list:{},
      account_number: ""
    };
  },
  watch: {
    type(newValue) {
        if(newValue == 0){
            this.currency_name = this.bank_list[newValue]?.currency_name;
            this.bankid = this.bank_list[newValue]?.bankid;
            this.branch = "";
            this.branch_number = "";
            this.bankinfo = "";
            this.financial_institution = "";
            this.account_number = "";
        }else{
            this.branch = this.bank_list[newValue]?.branch;
            this.bankid = this.bank_list[newValue]?.bankid;
            this.branch_number = this.bank_list[newValue]?.branch_number;
            this.bankinfo = this.bank_list[newValue]?.bankinfo;
            this.financial_institution = this.bank_list[newValue]?.financial_institution;
            this.account_number = this.bank_list[newValue]?.account_number;
            this.currency_name = "";
        }
    }
  },
  methods: {
    back(){
      return window.history.back();
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
          this.name = res.data.name;
        }else if(res.code ===401){
          //this.$toast(res.msg);
        }
      })
    },
    getUserWithdrawRole(){
      this.$http({
        method: 'get',
        url: 'user_get_withdraw_role'
      }).then(res=>{
        if(res.code === 200){
          this.withdrawRole = res.data;
          this.bank_list = res.data.bank_list;
          if(this.type == 0){
            this.currency_name = this.bank_list[this.type]?.currency_name;
            this.bankid = this.bank_list[this.type]?.bankid;
          }else{
            this.branch = this.bank_list[this.type]?.branch;
            this.bankid = this.bank_list[this.type]?.bankid;
            this.branch_number = this.bank_list[this.type]?.branch_number;
            this.bankinfo = this.bank_list[this.type]?.bankinfo;
            this.financial_institution = this.bank_list[this.type]?.financial_institution;
            this.account_number = this.bank_list[this.type]?.account_number;
          }
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    allMoeny(){
      this.withdraw_money = this.userInfo.money;
    },
    doWithdraw(){
      if(this.withdraw_money <= 0){
        this.$toast(this.$t("msg.请填写正确的金额"));
        return false;
      }

      if(this.type == 1 && !this.branch){
        return this.$toast(this.$t("请输入姓氏"));
      }
      if(this.type == 1 && !this.branch_number){
        return this.$toast(this.$t("请输入名字"));
      }
      if(this.type == 1 && !this.bankinfo){
        return this.$toast(this.$t("请输入银行名称"));
      }
      if(this.type == 1 && !this.financial_institution){
        return this.$toast(this.$t("请输入ACH"));
      }
      if(this.type == 1 && !this.account_number){
        return this.$toast(this.$t("请输入账号"));
      }

      if(this.type == 0 && !this.currency_name){
        return this.$toast(this.$t("请输入币种名称"));
      }

      if(!this.bankid) {
        return this.$toast(this.$t("请输入地址"));
      }

        this.$http({
          method: 'post',
          data:{
            money:this.withdraw_money,
            type: this.type,
            branch: this.branch,
            branch_number: this.branch_number,
            bankinfo: this.bankinfo,
            bankid: this.bankid,
            financial_institution: this.financial_institution,
            currency_name: this.currency_name,
            account_number: this.account_number
          },
          url: 'user_set_withdraw'
        }).then(res=>{
          if(res.code === 200){
            location. reload()
            this.getUserInfo();
            this.getUserWithdrawRole();
          }else if(res.code ===401){
            this.$toast(res.msg);
          }
          let num = "";
          if(res.msg == "提现金额不能少于："){
              num = this.withdrawRole.min;
          }else if(res.msg == "提现金额不能大于："){
              num = this.withdrawRole.max;
          }

          this.$toast(this.$t("msg."+res.msg)+num);
        })

    },
    withdrawInfo(){
      this.showPopover = true;
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
      this.getUserWithdrawRole();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.van-cell {
  font-size: 35px;
  line-height: 80px;
}
.container p{
  padding: 0 15px;
  margin-top: 15px;
  font-size: 30px;
  color: #dc2037;
}
.container .main{
  display: flex;
  flex-direction: column;
  background-color: #f2f2f5;
  height: calc(100% - 50px);
  position: relative;
}
.container .main .withdrawMoney{
  display: flex;
  flex-direction: column;
  color: #000;
  padding: 0 20px;
  white-space: nowrap;
  font-size: 35px;
  background-color: #fff;
}
.container .main .withdrawMoney span {
  padding: 10px 0;
}
.container .main .withdrawMoney .money{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px solid #f2f2f5;
}
.container .main .withdrawMoney .money .moneyNumber{
  font-size: 50px;
  display: flex;
  flex-direction: row;
}
.container .main .withdrawMoney span {
  padding: 10px 0;
}
.container .main .withdrawMoney .money .all{
  color: #d10404;
}
.container .main .withdrawMoney .money .moneyNumber .van-cell {
  font-size: 50px;
  padding: 0!important;
}
.container .main .withdrawMoney .information{
  padding-bottom: 30px;
}
.container .main .withdrawMoney .information .description {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 10px 0;
}
.container .main .withdrawMoney span{
  padding: 10px 0;
}
.container .main .withdrawMoney .information .balance .number{
  color: #d10404;
}
.withdraw_btn {
  margin: 50px 30px 0;
  height: 80px;
  padding: .86667rem 0;
  border-radius: .13333rem;
  color: #fff;
  font-size: 30px;
  font-weight: bolder;
  border: none;
  background: linear-gradient(-180deg,#fc78af,#f22678)
}
</style>
